import { array, boolean, mixed, number, object, string } from 'yup'

import {
  ReviewActivityActorType,
  ReviewActivityDecisionOutcome,
  ReviewActivityEventType,
  ReviewActivitySharingOutcome
} from './enums'

const reviewActivityPaginationSchema = object({
  currentPage: number().required(),
  perPage: number().required(),
  nextPage: number().nullable().optional(),
  prevPage: number().nullable().optional(),
  totalCount: number().required(),
  totalPages: number().required()
}).required()

const reviewActivityUserSnapshotSchema = object({
  _id: string().optional(),
  id: string().optional(),
  displayName: string().required(),
  email: string().required()
})
  .unknown(true)
  .default(undefined)

const reviewActivityActorSnapshotSchema = object({
  type: mixed<ReviewActivityActorType>().oneOf(Object.values(ReviewActivityActorType)).required(),
  displayName: string().required(),
  _id: string().optional(),
  id: string().optional(),
  email: string().optional()
})
  .unknown(true)
  .required()

const reviewActivityWorkspaceSnapshotSchema = object({
  _id: string().required(),
  name: string().required()
})
  .unknown(true)
  .default(undefined)

/**
 * OpenAPI lists `_id` as required but names the property `id`. Accept either so runtime
 * captures and the spec can disagree without breaking the feed.
 */
const reviewActivityLabelSnapshotSchema = object({
  name: string().required(),
  _id: string().optional(),
  id: string().optional()
})
  .unknown(true)
  .default(undefined)

const reviewActivityDecisionSchema = object({
  outcome: mixed<ReviewActivityDecisionOutcome>().oneOf(Object.values(ReviewActivityDecisionOutcome)).required()
})
  .unknown(true)
  .default(undefined)

const reviewActivitySharingSchema = object({
  outcome: mixed<ReviewActivitySharingOutcome>().oneOf(Object.values(ReviewActivitySharingOutcome)).required(),
  workspace: reviewActivityWorkspaceSnapshotSchema.required()
})
  .unknown(true)
  .default(undefined)

export const reviewActivityEventSchema = object({
  _id: string().required(),
  eventType: mixed<ReviewActivityEventType>().oneOf(Object.values(ReviewActivityEventType)).required(),
  occurredAt: string().required(),
  actor: reviewActivityActorSnapshotSchema,
  workspace: reviewActivityWorkspaceSnapshotSchema.optional(),
  previousAssignee: reviewActivityUserSnapshotSchema.nullable().optional(),
  newAssignee: reviewActivityUserSnapshotSchema.nullable().optional(),
  reviewConfirmed: boolean().optional(),
  label: reviewActivityLabelSnapshotSchema.optional(),
  decision: reviewActivityDecisionSchema.optional(),
  sharing: reviewActivitySharingSchema.optional()
})
  .unknown(true)
  .required()

export const reviewActivityListResponseSchema = object({
  data: array().of(reviewActivityEventSchema).required(),
  pagination: reviewActivityPaginationSchema
}).unknown(true)
